<template>
	<LabeledFieldLayout
		class="recurrence-offset-picker-field"
	>
		<div class="offset-fields">
			<TeamingDropDown
				class="offset-dropdown"
				:options="patchedOffsetOptions"
				:value="`${ offsetValue }`"
				@change="onOffsetChange"
			></TeamingDropDown>
			<TeamingDropDown
				class="offset-dropdown"
				:options="patchedDayOptions"
				:value="dayValue"
				@change="onDayChange"
			></TeamingDropDown>
		</div>
	</LabeledFieldLayout>
</template>

<script>

import {
	LabeledFieldLayout,
	TeamingDropDown
} from "@teaming/common-ui";

export const makeOption = ( {
	text = "",
	value = "",
} = {} ) => ( {
	text,
	value,
} );

export default {
	name: "RecurrenceDayOffsetPickerField",
	emits: [ "change", ],
	components: {
		LabeledFieldLayout,
		TeamingDropDown,
	},
	props: {
		dayOptions: {
			type: Array,
			required: true,
		},
		dayValue: {
			type: String,
			required: true,
		},
		offsetOptions: {
			type: Array,
			required: true,
		},
		offsetValue: {
			type: Number,
			required: true,
		},
	},
	computed: {
		patchedOffsetOptions() {
			const { offsetOptions, offsetValue, } = this;
			return offsetOptions.map( option => ( {
				...option,
				isSelected: ( offsetValue === option.value ),
			} ) );
		},
		patchedDayOptions() {
			const { dayOptions, dayValue, } = this;
			return dayOptions.map( option => ( {
				...option,
				isSelected: ( dayValue === option.value ),
			} ) );
		},
	},
	methods: {
		onOffsetChange( { value: dayOffsetField, } ) {
			const { dayValue, } = this;
			this.$emit( "change", {
				daysField: [ dayValue, ],
				dayOffsetField: parseInt( dayOffsetField, 10 ),
			} );
		},
		onDayChange( { value: day, } ) {
			const { offsetValue, } = this;
			this.$emit( "change", {
				daysField: [ day, ],
				dayOffsetField: offsetValue,
			} );
		},
	},
};
</script>

<style lang="scss" scoped>
.recurrence-offset-picker-field .offset-fields {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	gap: 0.5rem;
}

.recurrence-offset-picker-field .offset-dropdown {
	width: 100%;
}
</style>

<style lang="scss">
.recurrence-offset-picker-field .teaming-drop-down__options {
	// limit the height of the drop-down
	max-height: 11.5rem;
	@include auto-y-scroll();
}
</style>
